import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { getStageTheme } from './stageColorTheme';

interface FunnelStage {
  label: string;
  count: number;
  conversionRate: number;
}

interface HiringFunnelProps {
  data: FunnelStage[];
}

export function HiringFunnel({ data }: HiringFunnelProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Hiring Funnel</CardTitle>
        <CardDescription>
          Stage-by-stage conversion for the selected hiring year
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {data.length === 0 ? (
          <div className="text-sm text-muted-foreground">No funnel data available</div>
        ) : (
          data.map((stage) => {
            const theme = getStageTheme(stage.label);

            return (
            <div key={stage.label} className="space-y-2">
              <div className="flex items-center justify-between gap-4">
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <span className={`h-2.5 w-2.5 rounded-full ${theme.dot}`} aria-hidden="true" />
                    <div className="text-sm font-medium">{stage.label}</div>
                  </div>
                  <div className={`text-xs ${theme.text}`}>
                    {stage.conversionRate.toFixed(1)}% from previous stage
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-xl font-semibold">{stage.count}</div>
                </div>
              </div>
              <Progress value={stage.conversionRate} className="h-2" indicatorClassName={theme.progress} />
            </div>
            );
          })
        )}
      </CardContent>
    </Card>
  );
}
